// HelpPage.js
import React, { useState } from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBug, faTasks, faPlusSquare,faArrowRight, faArrowLeft  } from '@fortawesome/free-solid-svg-icons';

const HelpPage = () => {
  const [selection, setSelection] = useState("bugProgress"); // Default to the Bug-Progress Tracker tab
  const [loading, setLoading] = useState(true); // Manage loading state

  const handleSelectionChange = (event) => {
    setSelection(event.target.value);
    setLoading(true); // Set loading to true when a new tab is selected
  };

  const handleLoad = () => {
    setLoading(false); // Set loading to false when iframe is loaded
  };

  return (
    <div className="container mt-5 d-flex flex-column align-items-center">
      <h2 className="text-center mb-3">Need Help ?</h2>
      <p className="text-center">Trackers and Forms to report bugs, request features, and track their progress.</p>
      <div className="d-flex justify-content-center mb-3 w-100">
        <div className="btn-group mr-3" role="group" aria-label="Tracker options">
          <input
            type="radio"
            className="btn-check"
            name="helpOptions"
            id="bugProgressOption"
            value="bugProgress"
            onChange={handleSelectionChange}
            checked={selection === "bugProgress"}
          />
          <label className="btn btn-outline-primary" htmlFor="bugProgressOption">
          <FontAwesomeIcon icon={faTasks} /> Bug Tracker
          </label>

          <input
            type="radio"
            className="btn-check"
            name="helpOptions"
            id="featureProgressOption"
            value="featureProgress"
            onChange={handleSelectionChange}
            checked={selection === "featureProgress"}
          />
          <label className="btn btn-outline-primary" htmlFor="featureProgressOption">
          <FontAwesomeIcon icon={faTasks} /> Features Tracker
          </label>
        </div>

        <span className="align-self-center mx-2"><strong>Trackers Forms</strong></span>

        <div className="btn-group" role="group" aria-label="Form options">
          <input
            type="radio"
            className="btn-check"
            name="helpOptions"
            id="bugOption"
            value="bug"
            onChange={handleSelectionChange}
            checked={selection === "bug"}
          />
          <label className="btn btn-outline-primary" htmlFor="bugOption">
          <FontAwesomeIcon icon={faBug} /> Report a Bug
          </label>

          <input
            type="radio"
            className="btn-check"
            name="helpOptions"
            id="featureOption"
            value="feature"
            onChange={handleSelectionChange}
            checked={selection === "feature"}
          />
          <label className="btn btn-outline-primary" htmlFor="featureOption">
          <FontAwesomeIcon icon={faPlusSquare} />  Request a Feature
          </label>
        </div>
      </div>

      {loading && (
        <div className="text-center">
          <div className="spinner-border text-primary" role="status">
            <span className="sr-only">Loading...</span>
          </div>
        </div>
      )}

      {selection === "bugProgress" && (
        <iframe
          className="airtable-embed"
          src="https://airtable.com/embed/app2f1dhm61LXGobk/shrH5Z4ag7WkYpjOX"
          frameBorder="0"
          onmousewheel=""
          width="100%"
          height="533"
          style={{ background: 'transparent', border: '1px solid #ccc' }}
          onLoad={handleLoad}
        ></iframe>
      )}
      {selection === "featureProgress" && (
        <iframe
          className="airtable-embed"
          src="https://airtable.com/embed/app2f1dhm61LXGobk/shrqlWMZNtBMNaAUn?viewControls=on"
          frameBorder="0"
          onmousewheel=""
          width="100%"
          height="533"
          onLoad={handleLoad}
        ></iframe>
      )}
      {selection === "bug" && (
        <iframe
          className="airtable-embed"
          src="https://airtable.com/embed/app2f1dhm61LXGobk/pagiK4Yhtr25q9z8X/form"
          frameBorder="0"
          onmousewheel=""
          width="100%"
          height="533"
          onLoad={handleLoad}
        ></iframe>
      )}
      {selection === "feature" && (
        <iframe
          className="airtable-embed"
          src="https://airtable.com/embed/app2f1dhm61LXGobk/pagC6vmMDQNlMaPOu/form"
          frameBorder="0"
          onmousewheel=""
          width="100%"
          height="533"
          onLoad={handleLoad}
        ></iframe>
      )}
    </div>
  );
};

export default HelpPage;
